// components/maps/LocationMarker.jsx
import React, { useEffect } from 'react';
import { Marker, Popup, Circle, useMap } from 'react-leaflet';
import L from 'leaflet';

// User location icon with pulsing animation
const userLocationIcon = L.divIcon({
  html: `
    <div class="user-location-marker">
      <div class="pulse-ring"></div>
      <div class="pulse-dot"></div>
    </div>
  `,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
  className: 'custom-user-marker'
});

const LocationMarker = ({ 
  position, 
  showRadius = true, 
  radiusKm = 5,
  autoCenter = false,
  zoom = 14
}) => {
  const map = useMap();

  // Auto-center map on user location when it changes
  useEffect(() => {
    if (autoCenter && position) {
      map.setView([position.latitude, position.longitude], zoom);
    }
  }, [position, autoCenter, zoom, map]);

  if (!position) return null;

  return (
    <>
      {/* User Location Marker */}
      <Marker
        position={[position.latitude, position.longitude]}
        icon={userLocationIcon}
      >
        <Popup>
          <div className="text-center">
            <p className="font-semibold text-gray-900">Your Location</p>
            {position.accuracy && (
              <p className="text-xs text-gray-500 mt-1">
                Accuracy: ±{Math.round(position.accuracy)}m
              </p>
            )}
            {position.timestamp && (
              <p className="text-xs text-gray-400 mt-1">
                Updated: {new Date(position.timestamp).toLocaleTimeString()}
              </p>
            )}
          </div>
        </Popup>
      </Marker>

      {/* Radius Circle */}
      {showRadius && (
        <Circle
          center={[position.latitude, position.longitude]}
          radius={radiusKm * 1000}
          pathOptions={{
            color: '#3B82F6',
            fillColor: '#3B82F6',
            fillOpacity: 0.1,
            weight: 2,
            dashArray: '5, 10'
          }}
        />
      )}

      {/* Styles for the pulsing animation - embedded in component */}
      <style>{`
        .user-location-marker {
          position: relative;
          width: 20px;
          height: 20px;
        }
        
        .pulse-dot {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 12px;
          height: 12px;
          background-color: #3B82F6;
          border: 2px solid white;
          border-radius: 50%;
          box-shadow: 0 0 4px rgba(0,0,0,0.3);
          z-index: 2;
        }
        
        .pulse-ring {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20px;
          height: 20px;
          border: 2px solid #3B82F6;
          border-radius: 50%;
          animation: pulse-ring 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          z-index: 1;
        }
        
        @keyframes pulse-ring {
          0% {
            width: 20px;
            height: 20px;
            opacity: 1;
          }
          100% {
            width: 40px;
            height: 40px;
            opacity: 0;
          }
        }

        .custom-user-marker {
          background: transparent;
          border: none;
        }
      `}</style>
    </>
  );
};

export default LocationMarker;